export default "__VITE_ASSET__Nx3qdmFh__"